
import { useState, useEffect } from "react";
import { LogOut, LayoutDashboard } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";

export const BusinessMenu = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isDashboard = location.pathname.includes('/dashboard');
  const { isAuthenticated, isLoading, signOut } = useAuth();

  useEffect(() => {
    // Add scroll event listener
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50); // Show/hide based on scroll position
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll); // Clean up event listener
    };
  }, []);

  // In dashboard view, only show Logout button
  if (isDashboard) {
    return (
      <Button
        onClick={signOut}
        className="flex items-center gap-2 bg-gray-900/70 backdrop-blur-xl border border-gray-800 
          hover:border-gray-700 hover:bg-gray-800 hover:text-white transition-all duration-300
          shadow-lg shadow-purple-500/10"
        size="sm"
        disabled={isLoading}
      >
        <LogOut className="w-4 h-4" />
        <span>{isLoading ? "Signing out..." : "Sign Out"}</span>
      </Button>
    );
  }

  // For non-dashboard pages, don't show any buttons as HeroSection will handle it
  return null;
};
